import { render, staticRenderFns } from "./ModalBecomeDeveloper.vue?vue&type=template&id=6888efd9&"
import script from "./ModalBecomeDeveloper.vue?vue&type=script&lang=js&"
export * from "./ModalBecomeDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./ModalBecomeDeveloper.vue?vue&type=style&index=0&id=6888efd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports